import { Box, Icon, Tabs, Title } from '@inflearn/ds-react-next';
import { KoOnly } from '@inflearn/i18n-tools';
import { faArrowUpRightFromSquare } from '@inflearn/pro-solid-svg-icons';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { type ReactNode, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MyPageLayout from '../../../../components/layout/MyPageLayout';
import { INFLEARN_URL, MY_URL } from '../../../../constants/urls';

export function CourseRegistrationManagerLayout({
  children,
  title,
  description,
}: { children: ReactNode; title: string; description: string }) {
  const { t } = useTranslation();

  return (
    <MyPageLayout
      showChanneltalk={false}
      meta={{
        title,
        description,
      }}
    >
      <Title size={26} order={1} mb={8}>
        {t('구매 / 혜택')}
      </Title>
      <Box mb={16}>
        <CourseRegistrationManagerTabs />
      </Box>
      {children}
    </MyPageLayout>
  );
}

function CourseRegistrationManagerTabs() {
  const { t } = useTranslation();
  const router = useRouter();

  // 각 페이지에 맞는 탭 값 매칭
  const getTabValue = useCallback(() => {
    const giftsReceivedPath = new URL(MY_URL.GIFTS_RECEIVED()).pathname;
    const giftsSentPath = new URL(MY_URL.GIFTS_SENT()).pathname;
    const ordersPath = new URL(MY_URL.ORDERS()).pathname;

    if (router.pathname === giftsReceivedPath || router.pathname === giftsSentPath) {
      return MY_URL.GIFTS_RECEIVED();
    }

    if (router.pathname === ordersPath) {
      return MY_URL.ORDERS();
    }

    return router.pathname;
  }, [router.pathname]);

  const tabValue = useMemo(() => getTabValue(), [getTabValue]);

  return (
    <Tabs
      styles={{
        list: {
          flexWrap: 'nowrap',
        },
      }}
      value={tabValue}
      wrap="nowrap"
    >
      <Tabs.List>
        <Tabs.Tab component={Link} value={MY_URL.ORDERS()} href={MY_URL.ORDERS()}>
          {t('구매 내역')}
        </Tabs.Tab>
        <Tabs.Tab component={Link} value={MY_URL.GIFTS_RECEIVED()} href={MY_URL.GIFTS_RECEIVED()}>
          {t('선물함')}
        </Tabs.Tab>
        <KoOnly>
          <Tabs.Tab
            component="a"
            target="_blank"
            rightSection={<Icon icon={faArrowUpRightFromSquare} color="gray.5" size="xs" />}
            value={INFLEARN_URL.MY_COUPONS()}
            href={INFLEARN_URL.MY_COUPONS()}
          >
            쿠폰함
          </Tabs.Tab>
        </KoOnly>
        <KoOnly>
          <Tabs.Tab
            component="a"
            target="_blank"
            rightSection={<Icon icon={faArrowUpRightFromSquare} color="gray.5" size="xs" />}
            value={INFLEARN_URL.MY_POINTS()}
            href={INFLEARN_URL.MY_POINTS()}
          >
            포인트
          </Tabs.Tab>
        </KoOnly>
      </Tabs.List>
    </Tabs>
  );
}
